var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PortalPageShell',{attrs:{"icon":"mdi-file-document-outline","title":"Audit Report","subtitle":_vm.$t('portal.auditReport')}},[_c('AuditReport',{staticClass:"portal-page-fill"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }